// §11 Category-Registry — Label/Icon je Tool-Kategorie. Unbekannte Kategorie → „Sonstige"
// (PRD §11). Querschnitt (Rail/Tabs) liest NUR die Registry (§4) — hier die Anzeige-Meta.

export interface CategoryMeta {
  id: string;
  label: string;
  icon: string;
}

const KNOWN: Record<string, Omit<CategoryMeta, "id">> = {
  animation: { label: "Animation", icon: "film" },
  image: { label: "Bild", icon: "image" },
  "video-editor": { label: "Video", icon: "video" }, // §11 Seed (später)
};

export function categoryMeta(id: string): CategoryMeta {
  const known = KNOWN[id];
  return known ? { id, ...known } : { id, label: "Sonstige", icon: "tools" };
}

/** Stabile Reihenfolge der bekannten Kategorien (für die Rail), dann unbekannte angehängt. */
export function orderCategories(ids: string[]): string[] {
  const order = Object.keys(KNOWN);
  const known = order.filter((c) => ids.includes(c));
  const rest = ids.filter((c) => !order.includes(c));
  return [...known, ...rest];
}
